export enum TestType {
  Test = 'test',
  Quiz = 'quiz',
  Poll = 'poll',
  Crossword = 'crossword',
  Extended = 'extended',
}
